import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { LockFill } from 'react-bootstrap-icons';
import '../css/PayWall.css';

// Écran affiché à la place de Note / Besoin lorsque l'utilisateur n'a pas
// d'abonnement actif (expireDate absente ou passée, et rôle différent de admin).
const PaywallScreen = () => {
  const navigate = useNavigate();

  return (
    <div className="paywall-container">
      <LockFill size={48} className="paywall-icon" />
      <h1>Fonctionnalité réservée aux abonnés</h1>
      <h2 className="paywall-hint">
        Cet écran fait partie des fonctionnalités payantes de l'application.
        Pour y accéder, il vous faut un abonnement actif.
      </h2>
      <div className="paywall-actions">
        <Button
          className="paywall-button-primary"
            onClick={() => navigate('/profile', { state: { section: 'abo' } })}
        >
          Voir mon abonnement
        </Button>
        <Button
          className="paywall-button-link"
          onClick={() => navigate('/')}
        >
          Retour à l'accueil
        </Button>
      </div>
    </div>
  );
};

export default PaywallScreen;